import { useAsclepius } from "@/composables/api/asclepius"

const state = () => ({
  overdueMedicalChartsCount: 0
})

const getters = {
  overdueMedicalChartsCount: (state) => {
    return state.overdueMedicalChartsCount
  }
}

const actions = {
  async getOverdueMedicalChartsCount({ commit, rootGetters }) {
    const { getMedicalApi, callWithResponse } = useAsclepius()
    const requestParams = {
      overdueIn: true
    }
    if (rootGetters["me/isProvider"]) requestParams.providerId = rootGetters["me/providerId"]

    try {
      const response = await callWithResponse(() => getMedicalApi().listDynamicMedicalCharts(requestParams))

      commit("setOverdueMedicalChartsCount", {
        count: response.count
      })
    } catch (e) {
      console.error(e)
      return e
    }
  }
}

const mutations = {
  setOverdueMedicalChartsCount(state, { count }) {
    state.overdueMedicalChartsCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
